import React from 'react';
import { breakLines } from '../../utils/text';

class Text extends React.Component {
  static propTypes = {};

  render() {    
    const { lines, className, ...props } = this.props;
    let _className = className ? `${className} ` : '';
    _className += 'wwc-text';
    
    if(lines) {
      return (<p {...props} className={_className} dangerouslySetInnerHTML={{ __html: breakLines(lines) }} />);
    }

    return (<p className={_className} dangerouslySetInnerHTML={{ __html: this.props.children }} />);
  }
}

export default Text;
